import request from "/utils/request";

export default {
  get: sku => {
    let Url = "/api/credit_bundles";
    if (sku) {
      Url += `/${sku}`;
    }
    return request
      .get(Url, { token: true });
  },

  purchase: body => {
    const Url = "/api/credit_bundle_purchases";
    return request
      .post(Url, {
        body,
        token: true
      });
  }
};
